import moment from "moment/moment";
import React, { Fragment, useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";
import ReactDatePicker from "react-datepicker";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  appendVisa,
  applyVisaAsync,
  fetchMyVisaBookings,
  fetchVisaAsync,
  getApplyStatus,
  getVisaBookings,
  getVisaCounts,
  getVisaTypes,
  resetUpdateVisaStatus,
  resetVisaStatus,
  updateVisaAsync,
} from "../../../features/bookings/visaSlice";
import {
  callingCode,
  scrollFunc,
  slashFormatter,
} from "../../../helpers/helper";
import { useForm } from "../../../hooks/useForm";
import DocList from "./DocList";
import VisaDetails from "./VisaDetails";

const Visa = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const scrollToVisa = useRef(null);

  const visaType = useSelector(getVisaTypes);
  const visaCount = useSelector(getVisaCounts);
  const status = useSelector(getApplyStatus);
  const visaBookings = useSelector(getVisaBookings);

  const [selectedVisaType, setSelectedVisaType] = useState("1");
  const [travellers, setTravellers] = useState([]);
  const [visaDetails, setVisaDetails] = useState({});
  const typeRef = React.useRef("");

  const [editId, setEditId] = useState("");
  const updateVisaStatus = useSelector(
    (state) => state.visa.updateVisaStatus,
    shallowEqual
  );
  const AgeRegex = /^[0-9\b]+$/;

  const customDyncVadlidate = (name, regex, e, obj, ind) => {
    if (travellers[ind].Age !== "") {
      if (!AgeRegex.test(travellers[ind].Age)) {
        obj[name] = "Please Enter a Valid Age!";
      } else {
        delete obj[name];
      }
    }

    return obj;
  };

  const customValidate = (errors, ind) => {
    if (travellers[ind]["Age"] !== "" && !AgeRegex.test(travellers[ind].Age)) {
      errors.Age = "Please Enter a Valid Age!";
    }
    // else if(parseInt(travellers[ind]["Age"]) < 0){
    //   errors.Age = "Please Enter a Valid Age!"
    // }
    //  &&
    return errors;
  };

  const {
    state,
    isSubmit,
    formErrors,
    handleInputChange,
    setState,
    checkErrors,
    handleFormSubmit,
    handleInputDynamic,
    checkDyncErrors,
    setFormErrors,
    setIsSubmit,
  } = useForm({
    val: {
      Email: "",
      CountryCode: "",
      MobileNo: "",
      TravelDate: "",
    },
    dyncVals: {
      items: travellers,
      setItems: setTravellers,
      arrItems: ["Title", "FirstName", "LastName", "Age", "Gender"],
    },
    inDyncValidate: customValidate,
    inDyncCheckValidate: customDyncVadlidate,
  });

  const [show, setShow] = useState(false);
  const [modalData, setModalData] = useState({});
  const User = JSON.parse(sessionStorage.getItem("userData"));
  const [btnValue, setBtnValue] = useState("Upload Document");

  useEffect(() => {
    dispatch(fetchVisaAsync(User.Authorization));
    dispatch(fetchMyVisaBookings(User.Authorization));
    scrollToVisa.current?.scrollIntoView({ behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (updateVisaStatus) {
      // dispatch()
      dispatch(fetchMyVisaBookings(User.Authorization));
      setBtnValue("Upload Document");
      setTravellers([
        {
          Title: "",
          FirstName: "",
          LastName: "",
          Age: "",
          Gender: "",
        },
      ]);
      setState({ Email: "", MobileNo: "", CountryCode: "" });
      dispatch(resetUpdateVisaStatus());
      scrollToVisa.current?.scrollIntoView({ behavior: "smooth" });
      typeRef.current.value = visaType[0]?.id;
    }
  }, [updateVisaStatus]);

  useEffect(() => {
    setVisaDetails(visaType[0]);
    if (visaCount === 1) {
      let arr = [
        {
          Title: "",
          FirstName: "",
          LastName: "",
          Age: "",
          Gender: "",
        },
      ];
      setTravellers(arr);
    } else if (travellers.length < visaCount) {
      setTravellers([
        ...travellers,
        { Title: "", FirstName: "", LastName: "", Age: "", Gender: "" },
      ]);
    } else {
      let newArr = travellers.slice(0, -1);
      setTravellers(newArr);
    }
  }, [visaCount, visaType]);

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      let total = parseFloat(
        travellers.length *
          (parseInt(visaDetails.embassy_fee) +
            parseInt(visaDetails.service_fee) +
            parseInt(visaDetails.tax))
      );
      if (btnValue === "Update Document") {
        dispatch(
          updateVisaAsync({
            Authorization: User.Authorization,
            travellers,
            total,
            selectedVisaType,
            state,
            Id: editId,
          })
        );
        // dispatch(fetchMyVisaBookings(User.Authorization));
      } else {
        dispatch(
          applyVisaAsync({ travellers, total, selectedVisaType, User, state })
        );
      }
    }
  }, [formErrors, isSubmit]);

  useEffect(() => {
    if (status !== "") {
      if (status) {
        navigate(`/visa-document?id=${status.id}`);
        dispatch(resetVisaStatus());
      }
    }
  }, [status]);

  const editDocument = (vals) => {
    setIsSubmit(false);
    setState({
      ...state,
      Email: vals.email,
      CountryCode: vals.country_code,
      MobileNo: vals.contact_number,
      TravelDate: vals.travel_date,
    });
    let arr = [];
    vals?.visa_booking_details?.map((ele) => {
      arr.push({
        Title: ele.title,
        FirstName: ele.name,
        LastName: ele.surname,
        Age: ele.age,
        Gender: ele.gender,
      });
    });
    typeRef.current.value = vals?.visa_masters_id;
    setTravellers(arr);
    setBtnValue("Update Document");
    setEditId(vals.id);
    setFormErrors({});
  };

  const handleSelectVisa = (e) => {
    setSelectedVisaType(e.target.value);
    let arr = visaType.filter((ele) => {
      return parseInt(ele.id) === parseInt(e.target.value);
    });
    setVisaDetails(arr[0]);
  };

  const handleTravelDate = (e) => {
    setState({
      ...state,
      TravelDate: new Date(e.getTime() - e.getTimezoneOffset() * 60000)
        .toISOString()
        .split("T")[0],
    });
    delete formErrors["TravelDate"];
    // setFormErrors({ ...formErrors, dropDate: "" });
  };

  const remove = (ind) => {
    let arr = travellers.filter((ele, i) => {
      return i !== ind;
    });

    delete formErrors[ind];

    setTravellers(arr);
  };

  return (
    <>
      <section className="entry-form" ref={scrollToVisa}>
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <h4 className="title">Visa Type</h4>

              <div className="name-detail">
                <div>
                  <select onChange={handleSelectVisa} ref={typeRef}>
                    {visaType.length > 0 &&
                      visaType.map((val, i) => (
                        <option value={val.id} key={i}>
                          {val.typeofvisa}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="visa-type-wrap">
                  {visaType.length > 0 &&
                    visaType.map((data, i) => {
                      if (data.id === parseInt(selectedVisaType)) {
                        return (
                          <div key={i}>
                            <p>
                              Visa processing takes{" "}
                              <span>{data.processing_time}</span>
                            </p>
                            <p> {data.detail}</p>
                            <p>
                              Embassy Fees <span> {data.embassy_fee}</span>
                            </p>
                            <p>
                              Validity <span>{data.validity}</span>
                            </p>
                          </div>
                        );
                      }
                    })}
                </div>
              </div>

              <DocList />

              <div>
                <h4 className="title mt-5">Traveller Details</h4>
                <div className="name-detail guest-details-wrapper">
                  <form className="">
                    {travellers.map((ele, index) => (
                      <Fragment>
                        <h6>Traveller {index + 1}</h6>
                        <div
                          key={index}
                          className="guestDetails-wrapper mb-4 p-4"
                        >
                          <div className="row">
                            <div className="col-lg-2">
                              <div className="form-group title-wrap position-relative">
                                <div className="select-arrow"></div>
                                <label htmlFor="">Title</label>
                                <select
                                  name="Title[]"
                                  className="form-control"
                                  onChange={(e) => handleInputDynamic(index, e)}
                                  onBlur={(e) => checkDyncErrors(index, e)}
                                  value={ele.Title}
                                  defaultValue={ele.Title}
                                  autoComplete="off"
                                >
                                  <option value="">Title</option>
                                  <option value="Mr">Mr</option>
                                  <option value="Ms">Ms</option>
                                  <option value="Mrs">Mrs</option>
                                </select>
                                <span className="error">
                                  {formErrors[index]?.Title}
                                </span>
                              </div>
                            </div>
                            <div className="col-lg-5">
                              <div className="form-group">
                                <label>First Name</label>
                                <input
                                  type="text"
                                  name={"FirstName[]"}
                                  onChange={(e) => handleInputDynamic(index, e)}
                                  value={ele.FirstName}
                                  onBlur={(e) => checkDyncErrors(index, e)}
                                  autoComplete="off"
                                  placeholder="Enter First Name"
                                />
                                <span className="error">
                                  {formErrors[index]?.FirstName}
                                </span>
                              </div>
                            </div>
                            <div className="col-lg-5">
                              <div className="form-group">
                                <label>Last Name</label>
                                <input
                                  type="text"
                                  name={"LastName[]"}
                                  onChange={(e) => handleInputDynamic(index, e)}
                                  value={ele.LastName}
                                  onBlur={(e) => checkDyncErrors(index, e)}
                                  autoComplete="off"
                                  placeholder="Enter Last Name"
                                />
                                <span className="error">
                                  {formErrors[index]?.LastName}
                                </span>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="form-group">
                                <label>Age</label>
                                <input
                                  type="text"
                                  name={"Age[]"}
                                  onChange={(e) => handleInputDynamic(index, e)}
                                  value={ele.Age}
                                  onBlur={(e) => checkDyncErrors(index, e)}
                                  autoComplete="off"
                                  placeholder="Enter Age"
                                />
                                <span className="error">
                                  {formErrors[index]?.Age}
                                </span>
                              </div>
                            </div>

                            <div className="col-lg-6">
                              <div className="form-group">
                                <label>Gender</label>
                                <select
                                  name={"Gender[]"}
                                  onChange={(e) => handleInputDynamic(index, e)}
                                  value={ele.Gender}
                                  onBlur={(e) => checkDyncErrors(index, e)}
                                  autoComplete="off"
                                >
                                  <option value={""}>Select Gender</option>
                                  {["Male", "Female", "Other"].map(
                                    (ele, ind) => {
                                      return (
                                        <option
                                          key={ind}
                                          value={ele}
                                          defaultValue={ele.Gender}
                                        >
                                          {ele}
                                        </option>
                                      );
                                    }
                                  )}
                                </select>
                                <span className="error">
                                  {formErrors[index]?.Gender}
                                </span>
                              </div>
                            </div>
                          </div>

                          {index > 0 && (
                            <button
                              type="button"
                              className="cmn-btn remove-btn my-3"
                              onClick={() => {
                                remove(index);
                              }}
                            >
                              Remove
                            </button>
                          )}
                        </div>
                      </Fragment>
                    ))}

                    <button
                      type="button"
                      className="cmn-btn remove-btn my-3"
                      onClick={() => dispatch(appendVisa())}
                    >
                      Add Traveller
                    </button>

                    <div className="guestDetails-wrapper mb-3 border-0">
                      <div className="form-group">
                        <label>Email</label>
                        <input
                          type="email"
                          name={"Email"}
                          onChange={handleInputChange}
                          value={state.Email}
                          onBlur={(e) => checkErrors(e)}
                          autoComplete="off"
                          placeholder="Enter Email"
                        />
                        <span className="error">{formErrors?.Email}</span>
                      </div>
                      {/*  */}
                      <div className="form-group">
                        <label>Travel Date</label>
                        <ReactDatePicker
                          placeholderText="Travel Date"
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          dateFormat="yyyy-MM-dd"
                          name="TravelDate"
                          autoComplete="off"
                          minDate={Date.parse(
                            moment(new Date()).add(3, "days")
                          )}
                          selected={Date.parse(state.TravelDate)}
                          value={
                            state.TravelDate !== ""
                              ? slashFormatter(state.TravelDate)
                              : ""
                          }
                          onBlur={(e) => checkErrors(e)}
                          className="form-control"
                          onChange={handleTravelDate}
                        />

                        <span className="error">{formErrors?.TravelDate}</span>
                      </div>

                      {/*  */}
                      <div className="col-lg-6 col-md-6 p-0">
                        <div className="mobile-number">
                          <div className="form-group w-100">
                            <label for="">Mobile Number </label>
                            <div className="w-100">
                              <div className="position-relative select-country-code">
                                {/* <div className='select-arrow'></div> */}
                                <select
                                  name="CountryCode"
                                  className="form-control"
                                  // onFocus={(e) => setErrors(e)}
                                  autoComplete="off"
                                  value={state.CountryCode}
                                  // onBlur={(e) => setSingleError(e)}
                                  onBlur={(e) => checkErrors(e)}
                                  onChange={handleInputChange}
                                >
                                  <option value="">code</option>

                                  {callingCode.map((ele, ind) => (
                                    <option
                                      key={ind}
                                      value={ele.value}
                                      defaultValue={state.CountryCode}
                                    >
                                      {ele.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <input
                                type="text"
                                placeholder="Enter Mobile Number"
                                name="MobileNo"
                                value={state.MobileNo}
                                onChange={handleInputChange}
                                autoComplete="off"
                                onBlur={(e) => checkErrors(e)}
                                // onFocus={(e) => setErrors(e)}
                                // onBlur={(e) => setSingleError(e)}
                              />
                              <br />
                            </div>
                            <span className="error">
                              {formErrors?.CountryCode}
                            </span>
                            <span className="error">
                              {formErrors?.MobileNo}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <input
                      type="submit"
                      onClick={handleFormSubmit}
                      value={btnValue}
                    />
                  </form>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="name-detail my-visa-list-wrap">
                <div>
                  <h4>My visa details</h4>
                  {visaBookings.length > 0 ? (
                    visaBookings.map((data, i) => (
                      <div key={i}>
                        <p> {data.email}</p>
                        <span
                          className="cmn-btn"
                          onClick={() => {
                            setShow(true);
                            setModalData(data);
                          }}
                        >
                          View Details
                        </span>
                      </div>
                    ))
                  ) : (
                    <div className="no-visa">
                      <img src="./assets/images/no-visa.svg" />
                      <p className="mt-3">No visa yet</p>
                    </div>
                  )}
                  {/*  */}
                </div>
              </div>
            </div>

            {/*  */}
          </div>
        </div>

        {show ? (
          <VisaDetails
            setShow={setShow}
            show={show}
            modalData={modalData}
            editDocument={editDocument}
          />
        ) : null}
      </section>
    </>
  );
};

export default Visa;
